var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"hs-container",attrs:{"src":"https://www.720yun.com/vr/847jOdewtv8","frameborder":"no"}})
}
var staticRenderFns = []

export { render, staticRenderFns }